// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__iK18X","row":"default_row__TOM0b"};